const PUBLIC_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "yahoo.com",
  "yahoo.co.in",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "icloud.com",
  "me.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "yandex.com",
  "mail.com",
  "zoho.com",
  "hey.com",
  "pm.me",
]);

export function isPublicEmailDomain(emailAddress) {
  const email = String(emailAddress || "").trim().toLowerCase();
  const atIndex = email.lastIndexOf("@");
  if (atIndex < 1) return true;
  const domain = email.slice(atIndex + 1);
  return PUBLIC_EMAIL_DOMAINS.has(domain);
}

export function workEmailValidator(_, value) {
  if (!value) {
    return Promise.resolve();
  }
  if (isPublicEmailDomain(value)) {
    return Promise.reject(
      new Error("Please use your work email (no public domains)"),
    );
  }
  return Promise.resolve();
}

export const workEmailFormRules = [
  { required: true, message: "Please enter your work email" },
  { type: "email", message: "Please enter a valid email address" },
  { validator: workEmailValidator },
];
